/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Pause_Reasons_Create_ColorInputs */

const en_forms_pause_reasons_create_color = /** @type {(inputs: Forms_Pause_Reasons_Create_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color`)
};

const de_forms_pause_reasons_create_color = /** @type {(inputs: Forms_Pause_Reasons_Create_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbe`)
};

/**
* | output |
* | --- |
* | "Color" |
*
* @param {Forms_Pause_Reasons_Create_ColorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_pause_reasons_create_color = /** @type {((inputs?: Forms_Pause_Reasons_Create_ColorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Pause_Reasons_Create_ColorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_pause_reasons_create_color(inputs)
	return de_forms_pause_reasons_create_color(inputs)
});